import AppDispatcher from '../../dispatcher';
import { ActionTypes } from '../../state/ActionTypes';

const ActionCreators = {
  closeModal: (element) =>
    AppDispatcher.handleViewAction({
      actionType: ActionTypes.CLOSE_MODAL,
      element,
    }),

  openModal: (name, props) =>
    AppDispatcher.handleViewAction({
      actionType: ActionTypes.OPEN_MODAL,
      name,
      props,
    }),

  setAppNotificationMessage: (message) =>
    AppDispatcher.handleViewAction({
      actionType: ActionTypes.SET_APP_NOTIFICATION_MESSAGE,
      message,
    }),
};

export default ActionCreators;
